<template>
  <v-row>
    <v-col
      cols="12"
      lg="12">
      <article class="jdih-panel jdih-panel--grid h-100">
        <div class="jdih-panel__surface">
          <div class="jdih-panel__header">
            <div class="jdih-panel__titles">
              <h3 class="jdih-panel__title text-subtitle-1 font-weight-bold">
                Per jenis dokumen
              </h3>
              <p class="jdih-panel__subtitle text-caption mb-0">
                Agregat per jenis, per tahun
              </p>
            </div>
          </div>
          <div
            v-if="jdihSummaryTopLabel"
            class="jdih-summary mb-3">
            <div class="jdih-summary__line">
              Total produk hukum tahun {{ selectedYear }}:
              <strong>{{ jdihSummaryTotal }}</strong> dokumen
            </div>
            <div class="jdih-summary__line">
              Jenis terbanyak:
              <strong>{{ jdihSummaryTopLabel }}</strong>
            </div>
          </div>
          <v-alert
            v-if="jdihError"
            type="warning"
            dense
            text
            class="mb-0 jdih-panel__alert">
            {{ jdihError }}
          </v-alert>
          <div
            v-if="jdihLoading"
            class="jdih-chart-loading jdih-chart-loading--inset jdih-chart-loading--compact">
            <v-progress-circular
              indeterminate
              color="teal"
              size="44" />
            <div class="jdih-panel__hint mt-3">Memuat data…</div>
          </div>
          <client-only v-else-if="jdihHasChartData">
            <div class="jdih-panel__chart jdih-panel__chart--compact">
              <apexchart
                type="bar"
                :height="500"
                :options="jdihChartOptions"
                :series="jdihChartSeries" />
            </div>
          </client-only>
          <div
            v-else
            class="jdih-chart-placeholder jdih-chart-placeholder--inset jdih-chart-placeholder--compact">
            <v-icon
              color="grey lighten-1"
              class="mb-2">
              mdi-chart-box-outline
            </v-icon>
            <div class="jdih-panel__hint text-center">
              Belum ada data grafik
            </div>
          </div>
        </div>
      </article>
    </v-col>

    <v-col
      cols="12"
      lg="12">
      <article class="jdih-panel jdih-panel--grid h-100">
        <div class="jdih-panel__surface">
          <div class="jdih-panel__header">
            <div class="jdih-panel__titles">
              <h3 class="jdih-panel__title text-subtitle-1 font-weight-bold">
                Status produk hukum
              </h3>
              <p class="jdih-panel__subtitle text-caption mb-0">
                Per tahun · acuan {{ selectedYear }}
              </p>
            </div>
          </div>
          <div
            v-if="jdihStatusSummaryTopLabel"
            class="jdih-summary mb-3">
            <div class="jdih-summary__line">
              Total status tahun {{ selectedYear }}:
              <strong>{{ jdihStatusSummaryTotal }}</strong> dokumen
            </div>
            <div class="jdih-summary__line">
              Status terbanyak:
              <strong>{{ jdihStatusSummaryTopLabel }}</strong>
            </div>
          </div>
          <v-alert
            v-if="jdihStatusError"
            type="warning"
            dense
            text
            class="mb-0 jdih-panel__alert">
            {{ jdihStatusError }}
          </v-alert>
          <div
            v-if="jdihStatusLoading"
            class="jdih-chart-loading jdih-chart-loading--inset jdih-chart-loading--compact">
            <v-progress-circular
              indeterminate
              color="teal"
              size="44" />
            <div class="jdih-panel__hint mt-3">Memuat grafik status…</div>
          </div>
          <client-only v-else-if="jdihStatusHasChartData">
            <div class="jdih-panel__chart jdih-panel__chart--compact">
              <apexchart
                type="bar"
                :height="200"
                :options="jdihStatusChartOptions"
                :series="jdihStatusChartSeries" />
            </div>
          </client-only>
          <div
            v-else
            class="jdih-chart-placeholder jdih-chart-placeholder--inset jdih-chart-placeholder--compact">
            <v-icon
              color="grey lighten-1"
              class="mb-2">
              mdi-chart-box-outline
            </v-icon>
            <div class="jdih-panel__hint text-center">
              Belum ada data grafik status
            </div>
          </div>
        </div>
      </article>
    </v-col>

    <v-col
      cols="12"
      lg="12">
      <article class="jdih-panel jdih-panel--grid jdih-panel--last h-100">
        <div class="jdih-panel__surface">
          <div class="jdih-panel__header">
            <div class="jdih-panel__titles">
              <h3 class="jdih-panel__title text-subtitle-1 font-weight-bold">
                Per Kelompok Bidang
              </h3>
              <p class="jdih-panel__subtitle text-caption mb-0">
                Agregat per kelompok bidang, per tahun
              </p>
            </div>
          </div>
          <div
            v-if="jdihBidangSummaryTopLabel"
            class="jdih-summary mb-3">
            <div class="jdih-summary__line">
              Total bidang tahun {{ selectedYear }}:
              <strong>{{ jdihBidangSummaryTotal }}</strong> dokumen
            </div>
            <div class="jdih-summary__line">
              Bidang terbanyak:
              <strong>{{ jdihBidangSummaryTopLabel }}</strong>
            </div>
          </div>
          <v-alert
            v-if="jdihBidangError"
            type="warning"
            dense
            text
            class="mb-0 jdih-panel__alert">
            {{ jdihBidangError }}
          </v-alert>
          <div
            v-if="jdihBidangLoading"
            class="jdih-chart-loading jdih-chart-loading--inset jdih-chart-loading--compact">
            <v-progress-circular
              indeterminate
              color="teal"
              size="44" />
            <div class="jdih-panel__hint mt-3">Memuat grafik bidang…</div>
          </div>
          <client-only v-else-if="jdihBidangHasChartData">
            <div class="jdih-panel__chart jdih-panel__chart--compact">
              <apexchart
                type="bar"
                :height="500"
                :options="jdihBidangChartOptions"
                :series="jdihBidangChartSeries" />
            </div>
          </client-only>
          <div
            v-else
            class="jdih-chart-placeholder jdih-chart-placeholder--inset jdih-chart-placeholder--compact">
            <v-icon
              color="grey lighten-1"
              class="mb-2">
              mdi-chart-box-outline
            </v-icon>
            <div class="jdih-panel__hint text-center">
              Belum ada data grafik bidang
            </div>
          </div>
        </div>
      </article>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'JdihCharts',
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    chartHeightJdih: {
      type: Number,
      required: true
    },
    jdihLoading: {
      type: Boolean,
      default: false
    },
    jdihError: {
      type: String,
      default: ''
    },
    jdihHasChartData: {
      type: Boolean,
      default: false
    },
    jdihChartOptions: {
      type: Object,
      required: true
    },
    jdihChartSeries: {
      type: Array,
      default: () => []
    },
    jdihSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihSummaryTopLabel: {
      type: String,
      default: ''
    },
    jdihStatusLoading: {
      type: Boolean,
      default: false
    },
    jdihStatusSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihStatusSummaryTopLabel: {
      type: String,
      default: ''
    },
    jdihStatusError: {
      type: String,
      default: ''
    },
    jdihStatusHasChartData: {
      type: Boolean,
      default: false
    },
    jdihStatusChartOptions: {
      type: Object,
      required: true
    },
    jdihStatusChartSeries: {
      type: Array,
      default: () => []
    },
    jdihBidangLoading: {
      type: Boolean,
      default: false
    },
    jdihBidangSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihBidangSummaryTopLabel: {
      type: String,
      default: ''
    },
    jdihBidangError: {
      type: String,
      default: ''
    },
    jdihBidangHasChartData: {
      type: Boolean,
      default: false
    },
    jdihBidangChartOptions: {
      type: Object,
      required: true
    },
    jdihBidangChartSeries: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.jdih-panel {
  margin-bottom: 20px;
}

.jdih-panel--grid {
  margin-bottom: 0;
}

@media (max-width: 1263px) {
  .jdih-panel--grid:not(.jdih-panel--last) {
    margin-bottom: 20px;
  }
}

.jdih-panel--last {
  margin-bottom: 0;
}

.jdih-panel__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px 16px;
  margin-bottom: 14px;
  padding: 0 4px;
}

.jdih-panel__index {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(0, 105, 92, 0.08);
  color: #00695c;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jdih-panel__titles {
  flex: 1 1 160px;
  min-width: 0;
}

.jdih-panel__title {
  color: #0a1628;
  letter-spacing: -0.01em;
}

.jdih-panel__subtitle {
  color: rgba(10, 22, 40, 0.5);
  line-height: 1.4;
  margin-top: 0px !important;
}

.jdih-panel__surface {
  border-radius: 24px;
  border: 1px solid rgba(21, 73, 135, 0.12);
  background: #ffffff;
  padding: 16px;
  min-height: 120px;
  overflow: visible;
}

@media (min-width: 600px) {
  .jdih-panel__surface {
    padding: 16px;
  }
}

.jdih-panel__alert {
  border-radius: 8px !important;
}

.jdih-panel__chart {
  margin: 0 -4px;
}

.jdih-panel__hint {
  font-size: 0.8125rem;
  color: rgba(10, 22, 40, 0.45);
}

.jdih-summary {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(22, 50, 79, 0.1);
  background: rgba(23, 87, 184, 0.06);
}

.jdih-summary__line {
  font-size: 12px;
  color: #4d627c;
  line-height: 1.45;
}

.jdih-chart-placeholder {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px dashed rgba(10, 22, 40, 0.12);
  background: rgba(255, 255, 255, 0.6);
  padding: 32px 24px;
}

.jdih-chart-placeholder--inset {
  min-height: 280px;
}

.jdih-chart-loading {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.5);
  padding: 40px 24px;
}

.jdih-chart-loading--inset {
  min-height: 300px;
}

.jdih-chart-loading--compact {
  min-height: 200px;
  padding: 28px 16px;
}

.jdih-chart-placeholder--compact {
  min-height: 200px;
}

.jdih-panel__chart--compact {
  overflow: visible;
  position: relative;
  z-index: 1;
}

.jdih-panel__chart ::v-deep .apexcharts-tooltip {
  z-index: 50 !important;
  max-width: min(420px, calc(100vw - 32px)) !important;
  box-shadow: 0 8px 28px rgba(10, 22, 40, 0.18) !important;
}

.jdih-panel__chart ::v-deep .apexcharts-tooltip-text,
.jdih-panel__chart ::v-deep .apexcharts-tooltip-text-y-label,
.jdih-panel__chart ::v-deep .apexcharts-tooltip-text-y-value {
  white-space: normal !important;
  word-break: break-word;
}

.jdih-panel__chart ::v-deep .apexcharts-tooltip-series-group {
  max-height: min(320px, 55vh);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.jdih-panel__chart--jenis ::v-deep .apexcharts-tooltip {
  width: min(800px, calc(100vw - 24px)) !important;
  max-width: min(800px, calc(100vw - 24px)) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
}

.jdih-panel__chart--jenis ::v-deep .apexcharts-tooltip-title {
  grid-column: 1 / -1 !important;
}

.jdih-panel__chart--jenis ::v-deep .apexcharts-tooltip-series-group {
  display: inline-flex !important;
  min-width: 0;
  box-sizing: border-box;
  padding-right: 10px;
  vertical-align: top;
}

@media (max-width: 960px) {
  .jdih-panel__chart--jenis ::v-deep .apexcharts-tooltip-series-group {
    width: 100% !important;
    padding-right: 4px;
  }
}

@media (max-width: 960px) {
  .jdih-panel__chart--jenis ::v-deep .apexcharts-tooltip {
    grid-template-columns: 1fr;
  }
}
</style>
